angular.module('impactx.attributes').controller('AttributeSelectionCtrl', ['$scope', 'TranslationService', 'dataGen', AttributeSelectionCtrl]);

function AttributeSelectionCtrl($scope, TranslationService, dataGen) {
    $scope.enterDateLabel = TranslationService.get("enterDate");

    this.addAttribute = function () {
        $scope.attributeData.newAttributes.push({});
    };

    this.removeNewAttribute = function (index) {
        $scope.attributeData.newAttributes.splice(index, 1);
    };

    this.removeAttribute = function (index) {
        if (!$scope.attributeData.removedAttributes)
        {
            $scope.attributeData.removedAttributes = [];
        }
        $scope.attributeData.removedAttributes.push($scope.attributeData.attributes.splice(index, 1)[0]);
    };

    this.onPatSelect = function (selected, baseObject, searchText) {
        if (!baseObject.freeSelection) {
            baseObject.freeSelection = {value: null};
        }
        if (!selected || !selected.id) {
            baseObject.freeSelection.value = searchText;
        }
        else {
            baseObject.freeSelection.value = null;
            dataGen.getData({}, {patId: selected.id}, $scope.inputForPatEntryPoint).then(function (data) {
                baseObject.stringSettings = data.data.stringSettings;
                baseObject.booleanSettings = data.data.booleanSettings;
                baseObject.doubleSettings = data.data.doubleSettings;
                baseObject.integerSettings = data.data.integerSettings;
                baseObject.enumSettings = data.data.enumSettings;
                baseObject.dateSettings = data.data.dateSettings;
            });
        }
    };

    this.getPatList = function (searchText) {
        return dataGen.getData({}, {searchText: searchText}, $scope.patListEntryPoint, null, true).then(function (data) {
            return data.data.entries;
        });
    };

    this.patSearchTextChanged = function (selected, searchText, baseObject) {
        if (!baseObject.freeSelection) {
            baseObject.freeSelection = {value: null};
        }
        if (!selected || !selected.id) {
            baseObject.freeSelection.value = searchText;
            if (baseObject.stringSettings) {
                baseObject.stringSettings[0].label = searchText;
            }
            else {
                baseObject.stringSettings = [{paiId: 0, patId: 0, label: searchText, value: ""}];
            }
        }
        else {
            baseObject.freeSelection.value = null;
        }
    };
}